module.exports = __webpack_public_path__ + "static/media/BasicLayout.9c10b806.less";